@let _selectedOutage = selectedOutage();
@let _selectedMunicipality = selectedMunicipality();

@switch (powerOutagesResource.status()) {
  @case ('error') {
    <app-info-error-status />
  }
  @case ('loading') {
    <div class="e-content-loader e-content-loader--text"></div>
  }
  @default {
    <div class="relative">
      @if (showBackButton()) {
        <button
          type="button"
          class="e-btn e-btn--icon e-btn--circled absolute"
          (click)="onBackClick()"
          aria-label="Tilbake">
          <span class="e-btn__icon">
            <e-icon name="arrowLeftCircleColor" />
            <e-icon name="arrowLeftCircleFilledColor" />
          </span>
        </button>
      }
      <elvia-accordion
        type="normal"
        size="medium"
        isFullWidth
        [isOpen]="isOpen()"
        (onOpen)="setIsOpen(true)"
        (onClose)="setIsOpen(false)"
        spacingAboveContent="16px">
        <div slot="openLabel">
          <ng-container *ngTemplateOutlet="label" />
        </div>
        <div slot="closeLabel">
          <ng-container *ngTemplateOutlet="label" />
        </div>
        <div slot="content">
          @switch (view()) {
            @case ('idle') {
              @if (municipalitiesWithOutages().length) {
                <app-municipality-list />
              } @else {
                <app-unreported-outage-help />
              }
            }
            @case ('municipality') {
              <app-outage-list />
            }
            @case ('outage') {
              @if (_selectedOutage) {
                <app-outage-description [outage]="_selectedOutage" />
              }
            }
            @case ('outsideElviaArea') {
              <app-outside-elvia-area />
            }
            @case ('noOutage') {
              <app-unreported-outage-help />
            }
          }
        </div>
      </elvia-accordion>
    </div>
  }
}

<ng-template #label>
  <div [class.e-ml-40]="showBackButton()">
    @switch (view()) {
      @case ('idle') {
        @let count = municipalitiesWithOutages().length;
        @switch (count) {
          @case (0) {
            <p class="e-title-caps">Ingen kjente strømbrudd</p>
          }
          @case (1) {
            <p>{{ `Strømbrudd i ${municipalitiesWithOutages().at(0)!.name} kommune` }}</p>
          }
          @default {
            <p>{{ `Strømbrudd i ${(count | number)} kommuner` }}</p>
          }
        }
      }
      @case ('municipality') {
        @if (_selectedMunicipality) {
          @let count = _selectedMunicipality.outages.length;
          @switch (count) {
            @case (1) {
              {{ `Ett strømbrudd i ${_selectedMunicipality.name}` }}
            }
            @default {
              {{ `${(count | number)} strømbrudd i ${_selectedMunicipality.name} kommune` }}
            }
          }
        }
      }
      @case ('outage') {
        @if (_selectedOutage) {
          <p class="e-title-caps">
            {{ _selectedOutage.type | outageType }}
          </p>
        }
      }
      @case ('outsideElviaArea') {
        <p class="e-title-caps">Utenfor område</p>
      }
      @case ('noOutage') {
        <p class="e-title-caps">Ingen strømbrudd</p>
      }
    }
  </div>
</ng-template>
